/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Query_Identifiers_FrozenInputs */

const en_ledger_query_identifiers_frozen = /** @type {(inputs: Ledger_Query_Identifiers_FrozenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account identifier columns cannot change after accounts have been loaded.`)
};

const nl_ledger_query_identifiers_frozen = /** @type {(inputs: Ledger_Query_Identifiers_FrozenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificatiekolommen kunnen niet wijzigen nadat rekeningen zijn geladen.`)
};

/**
* | output |
* | --- |
* | "Account identifier columns cannot change after accounts have been loaded." |
*
* @param {Ledger_Query_Identifiers_FrozenInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_query_identifiers_frozen = /** @type {((inputs?: Ledger_Query_Identifiers_FrozenInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Query_Identifiers_FrozenInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_query_identifiers_frozen(inputs)
	return en_ledger_query_identifiers_frozen(inputs)
});